import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const dataImporterSelectors = importerSelectors('data.importer');

export default dataImporterSelectors;
